import styles from './EmployeeSelection.module.scss';

export const EmployeeSelection = () => {
  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <div className={styles.content}>
          <div className={styles.header}>
            <p className={styles.title}>Исполнители</p>
          </div>
          <div>На следующем шаге можно будет увидеть отклики исполнителей</div>
        </div>
      </div>
    </div>
  );
};
